import React, { useState,useEffect } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { UomTable } from "./UomTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchAll,
} from "./uomSlice";

export const AltUOMPage = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  // Filter
  const [materialName, setMaterialName] = useState("");
  const [uom, setUom] = useState("");
  const [nemurator, setNemurator] = useState("");
  const [denumerator, setDenumerator] = useState("");

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);



  const handleSearch = () => {
    const params = {
      materialName: materialName,
      uom: uom,
      nemurator: nemurator,
      denumerator: denumerator,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    dispatch(fetchAll(params));
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    const params = {
      materialName: materialName,
      uom: uom,
      nemurator: nemurator,
      denumerator: denumerator,
      pageNo: page,
      pageSize: sizePerPage,
    };
    dispatch(fetchAll(params));
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Alt Uom"></CardHeader>
      <CardBody>
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Material</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Material"
                    onChange={(e) => {
                      setMaterialName(e.target.value);
                    }}
                    value={materialName}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Uom</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Uom"
                    onChange={(e) => {
                      setUom(e.target.value);
                    }}
                    value={uom}
                  />
                </Col>
              </Form.Group>
              
            </Col>

            {/* Right Row */}
            <Col sm={6}>
            <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Nemurator</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Nemurator"
                    onChange={(e) => {
                      setNemurator(e.target.value);
                    }}
                    value={nemurator}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Denumerator</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Denumerator"
                    onChange={(e) => {
                      setDenumerator(e.target.value);
                    }}
                    value={denumerator}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Col>
              <Button className="btn btn-primary" onClick={handleSearch}>
                Search
              </Button>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}
        {data.length > 0 && (
          <UomTable
            data={data}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        )}
      </CardBody>
    </Card>
  );
};
